export default "__VITE_ASSET__D_Xow2h9__"